import { serializable, alias, object, list, primitive, createModelSchema, } from "serializr";
import { Institutes } from "./institutes.model";

class Board {
  @serializable(alias("id", primitive()))
  id?: number;

  @serializable(alias("acronym", primitive()))
  acronym?: string;

  @serializable(alias("name", primitive()))
  name?: string;
}
class ClassRooms {
  @serializable(alias("id", primitive()))
  classRoomId?: number;

  @serializable(alias("name", primitive()))
  name?: string;

  @serializable(alias("branch_class_room_id", primitive()))
  branchClassRoomId?: number;

}
export class Branches {
  @serializable(alias("id", primitive()))
  id?: number;

  @serializable(alias("id", primitive()))
  key?: number;

  @serializable(alias("name", primitive()))
  name?: string;

  @serializable(alias("board", object(Board)))
  board?: Board;

  @serializable(alias("institute", object(Institutes)))
  institute?: Institutes;

  @serializable(alias("contact_person", primitive()))
  contactPerson?: string;

  @serializable(alias("phone_number", primitive()))
  phoneNumber?: string;

  @serializable(alias("email", primitive()))
  email?: string;

  @serializable(alias("registered_address", primitive()))
  registeredAddress?: string;

  @serializable(alias("class_rooms", list(object(ClassRooms))))
  classRooms?: ClassRooms[] = [];

  @serializable(alias("is_active", primitive()))
  isActive?: boolean;

  @serializable(alias("display_logo_url", primitive()))
  logoUrl?: string;
}

export class CreateBranchClassRooms {
  @serializable(alias("class_room_id", primitive()))
  classRoomId?: number;

  // @serializable(alias("id", primitive()))
  // id?: number;

  // @serializable(alias("class_room", object(ClassRooms)))
  // classRoom?: ClassRooms;
}

export class IdNameModel {
  
  @serializable(alias("id", primitive()))
  id!: number;

  @serializable(alias("name", primitive()))
  name?: string;

}





class BranchClassRoomSectionsModel {
  @serializable(alias("id", primitive()))
  id?: number;

  @serializable(alias("name", primitive()))
  name?: string;

  @serializable(alias("section_subjects", list(object(IdNameModel))))
  sectionSubjects?: IdNameModel[] = [];
}

export class BranchClassRoomsModel {
  @serializable(alias("id", primitive()))
  id?: number;

  @serializable(alias("name", primitive()))
  name?: string;

  @serializable(alias("sections", list(object(BranchClassRoomSectionsModel))))
  sections?: BranchClassRoomSectionsModel[] = [];
 
  @serializable(alias("class_room", object(IdNameModel)))
  classRoom?: IdNameModel;
}

export class Branch {
  @serializable(alias("name", primitive()))
  name?: string;

  @serializable(alias("board_id", primitive()))
  boardId?: number;

  @serializable(
    alias("branch_class_rooms", list(object(CreateBranchClassRooms)))
  )
  branchClassRooms?: CreateBranchClassRooms[] = [];

  @serializable(alias("contact_person", primitive()))
  contactPerson?: string;

  @serializable(alias("phone_number", primitive()))
  phoneNumber?: string;

  @serializable(alias("registered_address", primitive()))
  registeredAddress?: string;

  @serializable(alias("email", primitive()))
  email?: string;

  @serializable(alias("is_active", primitive()))
  isActive?: boolean;

  @serializable(alias("institute_id", primitive()))
  instituteId?: number;
}
export class BranchMetaModel {
  @serializable(alias("id", primitive()))
  value?: number;

  @serializable(alias("name", primitive()))
  label?: string;
}

export class BranchClassRoomsMetaModel {
  @serializable(alias("id", primitive()))
  classRoomId?: number;
}
